import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const services = [
  {
    n: "01",
    title: "Investment Review",
    copy: "A forensic audit of your current holdings — what is working, what is quietly leaking returns, and what to fix first.",
  },
  {
    n: "02",
    title: "Fund Selection",
    copy: "Handpicked mutual funds matched to your risk profile, horizon and goals. Never a one-size-fits-all list.",
  },
  {
    n: "03",
    title: "SIP Solutions",
    copy: "Disciplined, automated investing that turns monthly income into long-term wealth — one step at a time.",
  },
  {
    n: "04",
    title: "Portfolio Reporting",
    copy: "Clear, jargon-free reports and real-time tracking on the Wealthy app, so you always know where you stand.",
  },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="bg-bone py-28 md:py-36">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <Eyebrow index="01" label="What we do" />
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-wealth mt-5 max-w-3xl">
          Four disciplines. One goal — <span className="italic text-wealth-light">your peace of mind.</span>
        </h2>
      </Reveal>

      <div className="mt-20">
        {services.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.08}>
            <div
              data-testid={`service-row-${s.n}`}
              className="group grid md:grid-cols-12 gap-4 md:gap-8 items-center border-t border-wealth/15 py-10 md:py-12 transition-colors duration-500 hover:bg-white"
            >
              <span className="md:col-span-2 font-display text-5xl md:text-6xl font-light text-wealth/20 group-hover:text-brand transition-colors duration-500">
                {s.n}
              </span>
              <h3 className="md:col-span-4 font-display text-3xl md:text-4xl font-medium tracking-tight text-wealth">
                {s.title}
              </h3>
              <p className="md:col-span-5 text-base leading-relaxed text-wealth/65">
                {s.copy}
              </p>
              <span className="hidden md:flex md:col-span-1 justify-end">
                <ArrowUpRight
                  size={30}
                  className="text-wealth/25 transition-[color,transform] duration-500 group-hover:text-brand group-hover:translate-x-1 group-hover:-translate-y-1"
                />
              </span>
            </div>
          </Reveal>
        ))}
        <div className="border-t border-wealth/15" />
      </div>
    </div>
  </section>
);
